import React from "react";
import Carousel from "react-bootstrap/Carousel";
import "./Banner.css";
import bgImg1 from "../../assets/img/hero-bg1.jpg";
import bgImg2 from "../../assets/img/hero-bg2.jpg";
import { Button } from "react-bootstrap";

const Banner = () => {
  return (
    <div className="container-fluid carousel-container p-0 banner-container">
      <Carousel>
        <Carousel.Item>
          <div
            style={{
              backgroundImage: `url(${bgImg1})`,
            }}
            className="carousel-item-container"
          ></div>
          <div className="overlay"></div>
          <div className="carousel-data-container">
            <div className="carousel-inner-data">
              <h3>First slide label</h3>
              <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
              <Button className="btn-banner">Discover Courses</Button>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div
            style={{
              backgroundImage: `url(${bgImg2})`,
            }}
            className="carousel-item-container"
          ></div>
          <div className="overlay"></div>
          <div className="carousel-data-container">
            <div className="carousel-inner-data">
              <h3>First slide label</h3>
              <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
              <Button className="btn-banner">Discover Courses</Button>
            </div>
          </div>
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default Banner;
